const BORRADOR = '0'
const EN_PROCESO = '1'
const FINALIZADO = '2'
const CONCILIADO = '3'
const ANULADO = '4'

const __dictionary = {
  [BORRADOR]: { id: BORRADOR, nombre: 'BORRADOR', color: 'secondary' },
  [EN_PROCESO]: { id: EN_PROCESO, nombre: 'EN PROCESO', color: 'warning' },
  [FINALIZADO]: { id: FINALIZADO, nombre: 'FINALIZADO', color: 'info' },
  [CONCILIADO]: { id: CONCILIADO, nombre: 'CONCILIADO', color: 'success' },
  [ANULADO]: { id: ANULADO, nombre: 'ANULADO', color: 'danger' }
}

const __array = Object.values(__dictionary)

export default Object.freeze({
  BORRADOR,
  EN_PROCESO,
  FINALIZADO,
  CONCILIADO,
  ANULADO,
  __dictionary,
  __array
})
